<template>
  <div class="totalCharts" id="totalCharts"></div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      myChart: null,
      option: null,
      clickData: [],
      click_status: false
    }
  },
  props: ['total', 'list'],
  watch: {
    list(val) {
      if (val) {
        this.init();
      }
    },
    clickData(val) {
      this.clickData = val
      this.myChart.clear()
      this.fn_option(this.clickData)
      this.myChart.setOption(this.option, true)
    }
  },
  methods: {
    init() {
      if (this.myChart) {
        this.myChart.dispose()
      }
      this.myChart = echarts.init(document.getElementById('totalCharts'))
      this.fn_option(this.list)
      this.myChart.setOption(this.option, true)
      this.myChart.on("click", param => {
        this.clickData = []
        this.click_status = !this.click_status
        if (this.click_status) {
          this.clickData.push(param.data)
        } else {
          this.clickData = this.list
        }
        this.$emit('change', {
          id: param.data.id,
          index: param.dataIndex
        })
      })
    },
    fn_option(list) {
      this.option = {
        tooltip: {
          trigger: 'item',
          // formatter: "{b}: {c} "
          formatter: function (params) {
            // if (!params || !params.value) return;
            // let formatterStr = '';
            // params.value.forEach((item, index) => {
            //   formatterStr = formatterStr.concat(
            //     // 外部变量
            //     `${userData.indicator[index].name}：${item ? item : 0}\n`,
            //   );
            // });
            // return `${params}\n${params}`;
            return params.data.name+params.data.value+' '+params.data.mixUnit
          }
        },
        title: {
          text: '疫苗总数',
          subtext: this.total,
          textStyle: {
            color: '#ffffff',
            fontSize: 10,
          },
          subtextStyle: {
            fontSize: 20,
            color: '#1CD3F3'
          },
          textAlign: 'center',
          // x: 'center',
          // y: 'center',
          left: '49%',
          top: '40%',
        },
        calculable: true,
        series: [
          {
            type: 'pie',
            radius: [50, 100],
            roseType: 'area',
            data: list
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.totalCharts {
  width: 100%;
  height: 280px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/component/totalCharts.vue